<template>
  <div class="layout mainLayout">
    <Layout>
      <MyHeader></MyHeader>
      <Layout>
        <Sider class="leftSiderStyle">
          <LeftSider></LeftSider>
        </Sider>
        <Layout class="contentContainer">
          <Content>
            <router-view></router-view>
          </Content>
        </Layout>
      </Layout>
      <Footer class="layout-footer-center"
        >2018-{{ currentYear }} &copy; 資通行動科技有限公司</Footer
      >
    </Layout>
  </div>
</template>
<script>
import dayjs from "dayjs";
import MyHeader from "@/components/Header.vue";
import LeftSider from "@/components/LeftSider.vue";
import { getCookie, getAllCookies } from "@/utilities/cookie";
import { loginResponse } from "@/utilities/api";
import Cookies from "js-cookie";

export default {
  created() {
    const token = Cookies.get("token");
    if (token === null || token === undefined)
      this.$router.replace({ name: "Login" });
  },
  computed: {
    currentYear() {
      return dayjs().format("YYYY");
    }
  },
  components: {
    MyHeader,
    LeftSider
  }
};
</script>
<style lang="scss" scoped>
.layout {
  position: relative;
  background: #f5f7f9;
  border: 1px solid #d7dde4;
  border-radius: 4px;
}
.mainLayout {
  .leftSiderStyle {
    min-height: 100vh;
    background-color: #fff;
  }
  .contentContainer {
    padding: 24px;
    > div {
      padding: 24px;
      background: #fff;
    }
  }
}
.layout-footer-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue